import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaStar, FaShieldAlt, FaComments } from 'react-icons/fa';
import Seo from '../../components/Seo/Seo';
import FeedbackForm from '../../components/FeedbackForm/FeedbackForm';

const Feedback = () => {
  return (
    <div>
      <Seo
        title="Leave Feedback"
        description="Share your experience with The Skilled Group and help other customers choose with confidence."
        canonicalPath="/feedback"
      />
      {/* Page Header */}
      <div className="page-header">
        <div className="container-custom">
          <h1>Share Your Feedback</h1>
          <p>
            Your feedback helps us improve and helps others discover The Skilled Group.
            We appreciate every review.
          </p>
        </div>
      </div>

      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
            {/* Feedback Form */}
            <div className="lg:col-span-2">
              <FeedbackForm />
            </div>

            {/* Sidebar */}
            <div className="space-y-6">
              {/* How it works */}
              <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border border-gray-100">
                <h3 className="text-lg font-heading font-semibold text-gray-800 mb-4">
                  How It Works
                </h3>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-primary-500 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0">
                      1
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800 text-sm">Submit Your Review</h4>
                      <p className="text-gray-500 text-xs mt-1">
                        Fill in your name and email, select a rating, and write your feedback.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-primary-500 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0">
                      2
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800 text-sm">Admin Review</h4>
                      <p className="text-gray-500 text-xs mt-1">
                        Our team reviews your feedback to ensure it's genuine and appropriate.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 bg-primary-500 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0">
                      3
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800 text-sm">Published</h4>
                      <p className="text-gray-500 text-xs mt-1">
                        Once approved, your feedback appears on our Testimonials page.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Why feedback matters */}
              <div className="bg-primary-50 rounded-2xl p-6 md:p-8 border border-primary-100">
                <h3 className="text-lg font-heading font-semibold text-primary-500 mb-4">
                  Why Your Feedback Matters
                </h3>
                <div className="space-y-3">
                  <div className="flex items-start gap-3">
                    <FaStar className="text-accent-500 mt-0.5 flex-shrink-0" />
                    <p className="text-gray-600 text-sm">
                      Helps us maintain high standards and improve our services.
                    </p>
                  </div>
                  <div className="flex items-start gap-3">
                    <FaComments className="text-accent-500 mt-0.5 flex-shrink-0" />
                    <p className="text-gray-600 text-sm">
                      Assists other customers in making informed decisions.
                    </p>
                  </div>
                  <div className="flex items-start gap-3">
                    <FaShieldAlt className="text-accent-500 mt-0.5 flex-shrink-0" />
                    <p className="text-gray-600 text-sm">
                      Builds trust and transparency in our community.
                    </p>
                  </div>
                </div>
              </div>

              {/* View testimonials */}
              <div className="bg-white rounded-2xl p-6 md:p-8 border border-gray-200 text-center">
                <h3 className="text-lg font-heading font-semibold text-gray-800 mb-3">
                  See What Others Say
                </h3>
                <p className="text-gray-500 text-sm mb-4">
                    Read reviews from other The Skilled Group customers on our Testimonials page.
                </p>
                <Link
                  to="/testimonials"
                  className="btn-outline text-sm py-2.5 px-6 inline-flex items-center gap-2"
                >
                  View Testimonials
                  <FaArrowRight className="text-xs" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Feedback;